export default "/images/1649fb76b9f510c9c470873b7deed2d8.avif";